export enum ContactKeys {
  authorizationEmail = 'authorizationEmail',
  axContactId = 'axContactId',
  businessEntityId = 'businessEntityId',
  contactId = 'contactId',
  dealerPortalEnabled = 'dealerPortalEnabled',
  email = 'email',
  firstName = 'firstName',
  inactive = 'inactive',
  lastName = 'lastName',
  mobilePhone = 'mobilePhone',
  phone = 'phone',
  prefEmail = 'prefEmail',
  prefPhone = 'prefPhone',
  prefText = 'prefText',
  title = 'title'
}

export interface IContact {
  [ContactKeys.authorizationEmail]: string;
  [ContactKeys.axContactId]?: string;
  [ContactKeys.businessEntityId]: number;
  [ContactKeys.contactId]: number;
  [ContactKeys.dealerPortalEnabled]: boolean;
  [ContactKeys.email]: string;
  [ContactKeys.firstName]: string;
  [ContactKeys.inactive]?: boolean;
  [ContactKeys.lastName]: string;
  [ContactKeys.mobilePhone]: string;
  [ContactKeys.phone]: string;
  [ContactKeys.prefEmail]: boolean;
  [ContactKeys.prefPhone]: boolean;
  [ContactKeys.prefText]: boolean;
  [ContactKeys.title]: string;
}

export interface IDeactivateContactRequest {
  businessEntityId: number;
  contactId: number;
}
